function updateFriendsCartNoteCounter(textarea) {
  const counterId = textarea.getAttribute('aria-describedby');
  const counter = counterId ? document.getElementById(counterId) : null;

  if (!counter?.matches('[data-friends-cart-note-counter]')) {
    return;
  }

  counter.textContent = counter.dataset.template.replace('__count__', textarea.value.length);
}

function initializeFriendsCartNoteCounters(root = document) {
  root.querySelectorAll('[data-friends-cart-note]').forEach(updateFriendsCartNoteCounter);
}

document.addEventListener('input', (event) => {
  if (event.target.matches('[data-friends-cart-note]')) {
    updateFriendsCartNoteCounter(event.target);
  }
});

document.addEventListener('focusin', (event) => {
  if (event.target.matches('[data-friends-cart-note]')) {
    updateFriendsCartNoteCounter(event.target);
  }
});

document.addEventListener('shopify:section:load', (event) => initializeFriendsCartNoteCounters(event.target));
initializeFriendsCartNoteCounters();
